import React from "react"
import { css } from "@emotion/core"
import styled from "@emotion/styled"
import CustomLink from "../Link"
import { palette } from "../../palette"

import "./button.scss"

function Button(props) {
  const SquareButtonStyles = css`
    color: ${props.text_color || '#fff'};
    background: ${palette[props.button_color.colors].color};
    &:hover {
      background: ${palette[props.button_color.colors].hover};
    }

    @media (max-width: 991px) {
      &.button__sign-up {
        /* //TODO: Change classname */
        color: ${props.color_theme === "light" ? `#000` : `#fff`};
        background: none;
      }
    }
  `

  const ArrowButtonStyles = css`
    color: ${palette[props.button_color.colors].color};
    .arrow {
      fill: ${palette[props.button_color.colors].color};
    }
  `

  const SquareButtonLink = styled(CustomLink)`
    ${SquareButtonStyles};
  `

  const ArrowButtonLink = styled(CustomLink)`
    ${ArrowButtonStyles};
  `

  // Square Button
  if (props.button_type === "square button") {
    return (
      <SquareButtonLink
        className={`button button__square ${props.className !== undefined &&
          props.className}`}
        url={props.button_link}
      >
        {props.button_text}
      </SquareButtonLink>
    )
  }

  // Arrow Button
  else if (props.button_type === "arrow button") {
    return (
      <ArrowButtonLink className="button button__arrow" url={props.button_link}>
        {props.button_text}
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            id="Artboard"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g id="baseline-arrow_forward-24px">
              <polygon id="Path" points="0 0 24 0 24 24 0 24" />
              <polygon
                className="arrow"
                id="Path"
                fillRule="nonzero"
                points="12 4 10.59 5.41 16.17 11 4 11 4 13 16.17 13 10.59 18.59 12 20 20 12"
              />
            </g>
          </g>
        </svg>
      </ArrowButtonLink>
    )
  }
  return null
}
export default Button
